import { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { useParams, useHistory, useLocation } from "react-router-dom";
import VehicleCard from "../VehicleCard";
import React from "react";
import { Link as Linkscroll } from "react-scroll";
import FinancingCarousel from "./FinancingCarousel";
import useFinanciaciones from "../../config/useFinanciaciones";
import useTitulosSeccion from "../../config/useTitulosSeccion";
import loading from "../../assets/loading.svg";
import { buildRouteWithUtms } from "../../config/whatsappConfig";

const VehicleList = ({ vehicles }) => {
  const [tipoSearch, setTipoSearch] = useState("todos");
  const [tipoToUse, setTipoToUse] = useState("todos");
  const [filtrados, setFiltrados] = useState(vehicles);

  let history = useHistory();
  let location = useLocation();
  let { tipo } = useParams();

  const { financiaciones, loading: loadingFinanciaciones } = useFinanciaciones();
  const { titulos } = useTitulosSeccion("0km");

  useEffect(() => {
    const validTipos = ["todos", "convencional", "plan", "grandesclientes", "preventa"];
    const search = location.search;

    if (!tipo || !validTipos.includes(tipo)) {
      history.replace(buildRouteWithUtms("/todos", search));
    }
  }, []);

  useEffect(() => {
    if (tipo === undefined) {
      setTipoToUse("todos");
    } else {
      setTipoToUse(tipo);
    }
  }, [tipo]);

  useEffect(() => {
    setTipoSearch(tipoToUse);
  }, [tipoToUse]);

  const handleTipo = (e) => {
    setTipoSearch(e);
    history.push(buildRouteWithUtms(`/${e}`, location.search));
  };

  //FILTRAR LOS VEHICULOS
  useEffect(() => {
    if (tipoSearch === "plan") {
      setFiltrados(vehicles.filter((item) => item.plan.habilitado === true));
    }

    if (tipoSearch === "convencional") {
      setFiltrados(vehicles.filter((item) => item.convencional.habilitado === true));
    }

    if (tipoSearch === "grandesclientes") {
      setFiltrados(vehicles.filter((item) => item.grandesclientes && item.grandesclientes.habilitado === true));
    }

    if (tipoSearch === "todos") {
      setFiltrados(vehicles);
    }
  }, [tipoSearch, vehicles]);

  const filtradosConvencional = vehicles.filter((item) => item.convencional.habilitado === true);

  const filtradosPlan = vehicles.filter((item) => item.plan.habilitado === true);

  const grandesClientes = vehicles.filter((item) => item.grandesclientes && item.grandesclientes.habilitado === true);

  const filtradosPreventa = vehicles.filter((item) => item?.preventa?.habilitado === true);

  // aqui guardamos los datos de utms

  /* sessionStorage.setItem('saludo', 'Bienvenidos a localStorage');
  valor = sessionStorage.getItem('saludo');
  */

  return (
    <>
      <Row id="scroll-click">
        <Col md={12} className="text-center">
          <h1 className="titMainPortada pt-5 pb-5 text-center">¡Llevate tu vehículo en Montironi!</h1>
        </Col>
      </Row>
      <Row className="pb-5" id="todos">
        <Col className="d-flex justify-content-center">
          {/*
            <Linkscroll
            to="scroll-click"
            className={`btn btn-blue m-2 ${tipoSearch !== "plan" && tipoSearch !== "convencional" && "active"}`}
            onClick={() => handleTipo("todos")}
          >
            Ver todo
          </Linkscroll>
          */}

          <Linkscroll
            className={`btn btn-blue_white m-2 ${tipoSearch === "convencional" || (tipoSearch === "todos" && "active")}`}
            onClick={() => handleTipo("convencional")}
            to="scroll-click"
          >
            0 KM
          </Linkscroll>
          <Linkscroll
            className={`btn btn-blue_white m-2 ${tipoSearch === "plan" && "active"}`}
            onClick={() => handleTipo("plan")}
            to="scroll-click"
          >
            Plan de Ahorro
          </Linkscroll>
          <Linkscroll
            className={`btn btn-blue_white m-2 ${tipoSearch === "grandesclientes" && "active"}`}
            onClick={() => handleTipo("grandesclientes")}
            to="scroll-click"
          >
            Ford Pro
          </Linkscroll>
          {/*
        
          <Linkscroll
            className={`btn btn-blue m-2 ${tipoSearch === "preventa" && "active"}`}
            onClick={() => handleTipo("preventa")}
            to="scroll-click"
          >
            Futuros Vehículos
          </Linkscroll>
            */}
        </Col>
      </Row>

      {tipoSearch === "convencional" || tipoSearch === "todos" ? (
        <div id="convencional">
          <Row className="d-flex">
            <h2 className="titulo-categorias-home mb-0 d-flex align-items-center flex-wrap">
              {titulos.tituloPrincipal}
              {titulos.items?.map((item, i) => (
                <span key={i} className="d-flex align-items-center">
                  <span className="mx-2 titulo-seccion-bullet">•</span>
                  <span className={i === 0 ? "titulo-seccion-item--destacado" : "titulo-seccion-item--normal"}>
                    {item.texto}
                  </span>
                </span>
              ))}
            </h2>
          </Row>

          <Row>
            <Col>
              {loadingFinanciaciones ? (
                <Row className="d-flex justify-content-center mb-5">
                  <img src={loading} alt="Cargando..." style={{ width: 100, height: 100 }} />
                </Row>
              ) : financiaciones && financiaciones.length > 0 ? (
                <FinancingCarousel financiaciones={financiaciones} />
              ) : null}
            </Col>
          </Row>
          <Row className="d-flex">
            {filtradosConvencional && filtradosConvencional.length > 0 ? (
              filtradosConvencional
                .sort((a, b) => a.convencional.prioridad - b.convencional.prioridad)
                .map((item, index) => (
                  <Col lg={4} md={6} xs={12} key={index} className="flex-wrap mb-4">
                    <VehicleCard
                      info={item}
                      tipo={tipoSearch}
                      filtrados={filtradosConvencional}
                      nombreTipo="convencional"
                      todosLosVehiculos={vehicles}
                    />
                  </Col>
                ))
            ) : (
              <>
                <p className="text-center pt-5 pb-5">Proximamente más opciones disponibles.</p>
              </>
            )}
          </Row>
        </div>
      ) : null}

      {tipoSearch === "plan" || tipoSearch === "todos" ? (
        <div className={tipoSearch === "plan" ? null : "mt-5"} id="plan">
          <Row className="d-flex">
            <h2 className="titulo-categorias-home">PLANES DE AHORRO</h2>
          </Row>
          <Row className="d-flex">
            {filtradosPlan && filtradosPlan.length > 0 ? (
              filtradosPlan
                .sort((a, b) => a.plan.prioridad - b.plan.prioridad)
                .map((item, index) => (
                  <Col lg={4} md={6} xs={12} key={index} className="flex-wrap mb-4">
                    <VehicleCard
                      info={item}
                      tipo={tipoSearch}
                      filtrados={filtradosPlan}
                      nombreTipo="plan"
                      todosLosVehiculos={vehicles}
                    />
                  </Col>
                ))
            ) : (
              <>
                <p className="text-center pt-5 pb-5">Proximamente más opciones disponibles.</p>
              </>
            )}
          </Row>
        </div>
      ) : null}

      {/*
      {tipoSearch === "preventa" || tipoSearch === "todos" ? (
        <div className={tipoSearch === "preventa" ? null : "mt-5"} id="preventa">
          <Row className="d-flex">
            <h2 className="titulo-categorias-home">Futuros Vehículos</h2>
          </Row>
          <Row className="d-flex">
            {filtradosPreventa && filtradosPreventa.length > 0 ? (
              filtradosPreventa
                .sort((a, b) => a.preventa.prioridad - b.preventa.prioridad)
                .map((item, index) => (
                  <Col lg={4} md={6} xs={12} key={index} className="flex-wrap mb-4">
                    <VehicleCard
                      info={item}
                      tipo={tipoSearch}
                      filtrados={filtradosPreventa}
                      nombreTipo="preventa"
                      todosLosVehiculos={vehicles}
                    />
                  </Col>
                ))
            ) : (
              <>
                <p className="text-center pt-5 pb-5">Proximamente más opciones disponibles.</p>
              </>
            )}
          </Row>
        </div>
      ) : null}
      */}
      {tipoSearch === "grandesclientes" || tipoSearch === "todos" ? (
        <div className={tipoSearch === "grandesclientes" ? null : "mt-5"} id="grandesclientes">
          <Row className="d-flex">
            <h2 className="titulo-categorias-home">Ford Pro</h2>
          </Row>
          <Row className="d-flex">
            {grandesClientes && grandesClientes.length > 0 ? (
              grandesClientes
                .sort((a, b) => a.grandesclientes.prioridad - b.grandesclientes.prioridad)
                .map((item, index) => (
                  <Col lg={4} md={6} xs={12} key={index} className="flex-wrap mb-4">
                    <VehicleCard
                      info={item}
                      tipo={tipoSearch}
                      filtrados={grandesClientes}
                      nombreTipo="grandesclientes"
                      todosLosVehiculos={vehicles}
                    />
                  </Col>
                ))
            ) : (
              <>
                <p className="text-center pt-5 pb-5">Proximamente más opciones disponibles.</p>
              </>
            )}
          </Row>
        </div>
      ) : null}
    </>
  );
};

export default VehicleList;

